import { memo, useEffect, useState } from 'react';
import { Grid, Column as ColumnBase, Title as TitleBase, SubTitle as SubTitleBase } from '@bidalihq/ui';
import Image from 'next/image';
import tw from 'tailwind-styled-components';
import clsx from 'clsx';

import Section from '@/components/section';

const Column = tw(ColumnBase)`
  flex
  flex-col
  justify-center
  h-full
`;

const Title = tw(TitleBase)`
  text-left
  font-inter
  text-[#547B45]
`;

const SubTitle = tw(SubTitleBase)`
  text-[#4d9531]
`;

const ImageContainer = tw.div`
  relative
  h-full
  w-full
  min-h-[90vw]
  md:min-h-0
`;

const Content = tw.div`
  bg-[#DBFECE]
  p-8
  rounded-2xl
  shadow-double

  lg:px-16
  lg:py-14
`;

const Hero = () => {
  const [showImage, setShowImage] = useState(false);

  const imageClassNames = clsx('transition-opacity', 'object-contain', {
    'opacity-0': !showImage,
    'opacity-100': showImage
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowImage(true);
    }, 250);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <Section className="md:pt-8 md:pb-0">
      <Content>
        <Grid columns={[1, 3]}>
          <Column span={[1, 2]}>
            <Title>Super charge your incentive program</Title>
            <SubTitle>Enhance your HR toolkit with seamless payout solutions—magnetize top talent, elevate your brand, and cultivate lasting client loyalty.</SubTitle>
          </Column>
          <Column span={1}>
            <ImageContainer>
              <Image
                alt="Futuristic starbucks coin"
                className={imageClassNames}
                fill
                priority
                sizes="100%"
                src="/images/trophy.webp"
              />
            </ImageContainer>
          </Column>
        </Grid>
      </Content>
    </Section>
  );
};

export default memo(Hero);
